module.exports = __webpack_public_path__ + "staticcomp/img/top.03cc36f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/8/top.jpg
// module id = c/CP
// module chunks = 39